module.exports = __webpack_public_path__ + "images/db2d851e7f5fd14cd29dab6d78654937-MSW_LineArt_PanelSwap_IQ4H-IQ4H_Slide5.png";